import { useEffect, useState } from 'react'

/** Whether a media query matches, live. Where matchMedia is missing (tests),
 *  `fallback` stands in — desktop by default. */
export function useMediaQuery(query: string, fallback = false): boolean {
  const get = () =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(query).matches
      : fallback
  const [matches, setMatches] = useState(get)
  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const mq = window.matchMedia(query)
    const on = () => setMatches(mq.matches)
    on()
    mq.addEventListener('change', on)
    return () => mq.removeEventListener('change', on)
  }, [query])
  return matches
}

/** Tailwind's md breakpoint: below it the console is the phone layout. */
export const useIsDesktop = () => useMediaQuery('(min-width: 768px)', true)
/** lg: from here a detail opens as a drawer beside the list. */
export const useIsWide = () => useMediaQuery('(min-width: 1024px)', true)
